import { render, staticRenderFns } from "./myExpenseTable.vue?vue&type=template&id=6d312442&scoped=true&"
import script from "./myExpenseTable.vue?vue&type=script&lang=js&"
export * from "./myExpenseTable.vue?vue&type=script&lang=js&"
import style0 from "./myExpenseTable.vue?vue&type=style&index=0&id=6d312442&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d312442",
  null
  
)

export default component.exports